export default __webpack_public_path__ + "static/media/pikachu-background.b5b71e36.jpg";